import React from "react"
import { CallRowViewModel } from "../../ViewModels/IndexContainerViewModels"
import MonitoringCallIndexRow from "./MonitoringCallIndexRow"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import Tab from "@mui/material/Tab"
import Grid from "@mui/material/Grid"

const styles = {
    tableCell: {
        padding: '4px 12px 4px 12px',
    }
}

interface IMonitoringCallIndexTableProps {
    callId: string
    calls: CallRowViewModel[]
    setId: (newId: string) => void
    callSwitchEnabled: boolean
    failedToLoad: boolean
}

export default function MonitoringCallIndexTable(props: IMonitoringCallIndexTableProps) {
    return (
        <>
            <Grid container justifyContent="center">
                <Tab label="Call History" />
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={styles.tableCell}><b>Agent Name</b></TableCell>
                        <TableCell sx={styles.tableCell}><b>Event Time</b></TableCell>
                        <TableCell sx={styles.tableCell}><b>Call Length</b></TableCell>
                        <TableCell sx={styles.tableCell}><b>Channel</b></TableCell>
                        <TableCell sx={styles.tableCell}><b>Status</b></TableCell>
                        <TableCell sx={styles.tableCell}><b>Result</b></TableCell>
                        <TableCell sx={styles.tableCell}><b>Phone Number</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.failedToLoad &&
                        <TableRow>
                            <TableCell align="center" colSpan={7} sx={styles.tableCell}>Failed to load call history</TableCell>
                        </TableRow>
                    }
                    {props.calls.length > 0 && !props.failedToLoad && props.calls.map((row) => {
                        return (
                            <MonitoringCallIndexRow
                                callId={props.callId}
                                key={row.systemPK}
                                call={row}
                                setId={props.callSwitchEnabled ? props.setId : undefined}
                            />
                        );
                    })
                    }
                </TableBody>
            </Table>
        </>
    );
}
